(function() {
  var toggles = document.querySelectorAll('[data-collapse-storage]');
  if (!toggles.length || !window.localStorage) return;

  var getStoredState = function(storageKey) {
    try {
      return window.localStorage.getItem(storageKey);
    } catch (error) {
      return null;
    }
  };

  var setStoredState = function(storageKey, isExpanded) {
    try {
      window.localStorage.setItem(storageKey, isExpanded ? 'expanded' : 'collapsed');
    } catch (error) {
      // Ignore storage access failures and keep the UI functional.
    }
  };

  for (var i = 0; i < toggles.length; i++) {
    var toggle = toggles[i];
    var storageKey = toggle.getAttribute('data-collapse-storage');
    var panelId = toggle.getAttribute('aria-controls');
    var panel = panelId ? document.getElementById(panelId) : null;

    if (!storageKey || !panel) continue;

    var storedState = getStoredState(storageKey);
    if (storedState === 'expanded') {
      panel.classList.remove('hide');
      toggle.setAttribute('aria-expanded', 'true');
    } else if (storedState === 'collapsed') {
      panel.classList.add('hide');
      toggle.removeAttribute('aria-expanded');
    }

    toggle.addEventListener('click', (function(currentToggle, currentStorageKey) {
      return function() {
        setStoredState(currentStorageKey, currentToggle.getAttribute('aria-expanded') === 'true');
      };
    })(toggle, storageKey));
  }
}());
